import * as TotalPointsModel from "../datamodel/total-points.datamodel";

export async function getValue(): Promise<number> {
    return await TotalPointsModel.getValue();
}

export async function updateInsertValue(points: number) {
    return await TotalPointsModel.putValue(points);
}
